import { classToPlain, plainToClass } from '../../../../node_modules/.pnpm/class-transformer@0.5.1/node_modules/class-transformer/esm5/index.js';
import cjs from '../../../../node_modules/.pnpm/deepmerge@4.2.2/node_modules/deepmerge/dist/cjs.js';

function deepMerge(model, target, partial) {
  var plainTarget = classToPlain(target);
  var plainPartial = classToPlain(partial);
  var plain = cjs(plainTarget, plainPartial); // TODO casting == bad
  return plainToClass(model, plain);
}

export { deepMerge as default };
//# sourceMappingURL=deepMerge.js.map
